import { useConfigStore } from '@/store/config.store';
import { storeToRefs } from 'pinia';

export function useGrid() {
    const { displayGrid } = storeToRefs(useConfigStore());

    function toggleGrid() {
        displayGrid.value = !displayGrid.value;
    }

    return {
        toggleGrid,
        displayGrid,
    };
}
